<template>
    <p v-if="haveCreditors != null && !haveCreditors" class="text-center">
        You Don’t Have Any <strong>Creditors Reporting</strong>. Please Import A <strong>Credit Report</strong>.
    </p>
    <div v-show="isInputFormActive && haveCreditors" class="row text-center mx-auto prev-item justify-content-center">
        <pagination :data="creditors" @pagination-change-page="getCreditors" />
    </div>
    <!-- Card Advance -->
    <div v-show="isInputFormActive && haveCreditors" class="row match-height">
        <!-- Developer Meetup Card -->
        <template v-for="creditor in creditors.data">
            <div class="col-lg-3 col-md-3 col-12">
                <div class="card card-developer-meetup">
                    <div class="card-body">
                        <div class="meetup-header d-flex align-items-center">
                            <div class="my-auto">
                                <h4 class="card-title mb-25">{{ creditor.creditor_name }}</h4>
                            </div>
                        </div>
                        <div class="media">
                            <div class="avatar bg-light-primary rounded mr-1">
                                <div class="avatar-content">
                                    <i data-feather="phone" class="avatar-icon font-medium-3"></i>
                                </div>
                            </div>
                            <div class="media-body">
                                <h6 class="mb-0">Phone</h6>
                                <small>{{ creditor.phone }}</small>
                            </div>
                        </div>
                        <div class="media">
                            <div class="avatar bg-light-primary rounded mr-1">
                                <div class="avatar-content">
                                    <i data-feather="map-pin" class="avatar-icon font-medium-3"></i>
                                </div>
                            </div>
                            <div class="media-body">
                                <h6 class="mb-0">Address</h6>
                                <small>{{ creditor.address }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <a href="#" @click="selectedCreditor(creditor)" type="button" class="btn btn-primary btn-block">Create</a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack">{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                            <div class="row mb-2">
                                <div class="col-4">
                                    <label for="common-remedies-tila-violation">Common Remedies TILA Violations </label>
                                    <Select2
                                        v-model="selectedRemedyTilaViolation"
                                        :settings="{
                                            multiple: true,
                                            ajax: {
                                                url: $router.resolve({
                                                    name: 'affidavitletter-categories',
                                                }).href,
                                                dataType: 'json',
                                                delay: 250,
                                                data: function (params) {
                                                    return {
                                                        search: params.term,
                                                        type: 'tila-violation'
                                                    };
                                                },
                                                processResults: (data) => {
                                                    return {
                                                        results: data.results.map((item) => {
                                                            return { id: item.affidavit, text: item.text };
                                                        })
                                                    }
                                                }
                                            }
                                        }"
                                        @change="myChangeEvent($event)"
                                        @select="mySelectEvent($event)"
                                    />
                                </div>
                                <div class="col-4">
                                    <label for="common-remedies-fdcpa-violations">Common Remedies FDCPA Violations </label>
                                    <Select2
                                        v-model="selectedRemedyFdcpaViolation"
                                        :settings="{
                                            multiple: true,
                                            ajax: {
                                                url: $router.resolve({
                                                    name: 'affidavitletter-categories',
                                                }).href,
                                                dataType: 'json',
                                                delay: 250,
                                                data: function (params) {
                                                    return {
                                                        search: params.term,
                                                        type: 'fdcpa-violation'
                                                    };
                                                },
                                                processResults: (data) => {
                                                    return {
                                                        results: data.results.map((item) => {
                                                            return { id: item.affidavit, text: item.text };
                                                        })
                                                    }
                                                }
                                            }
                                        }"
                                        @change="myChangeEvent($event)"
                                        @select="mySelectEvent($event)"
                                    />
                                </div>
                                <div class="col-4">
                                    <label for="common-remedies-fcra-violations">Common Remedies FCRA Violations </label>
                                    <Select2
                                        v-model="selectedRemedyFcraViolation"
                                        :settings="{
                                            multiple: true,
                                            ajax: {
                                                url: $router.resolve({
                                                    name: 'affidavitletter-categories',
                                                }).href,
                                                dataType: 'json',
                                                delay: 250,
                                                data: function (params) {
                                                    return {
                                                        search: params.term,
                                                        type: 'fcra-violation'
                                                    };
                                                },
                                                processResults: (data) => {
                                                    return {
                                                        results: data.results.map((item) => {
                                                            return { id: item.affidavit, text: item.text };
                                                        })
                                                    }
                                                }
                                            }
                                        }"
                                        @change="myChangeEvent($event)"
                                        @select="mySelectEvent($event)"
                                    />
                                </div>
                                <div class="col-4">
                                    <label for="common-remedies-glb-violation">Common Remedies Gram Leach Bailey Violations </label>
                                    <Select2
                                        v-model="selectedRemedyGlbViolation"
                                        :settings="{
                                            multiple: true,
                                            ajax: {
                                                url: $router.resolve({
                                                    name: 'affidavitletter-categories',
                                                }).href,
                                                dataType: 'json',
                                                delay: 250,
                                                data: function (params) {
                                                    return {
                                                        search: params.term,
                                                        type: 'glb-violation'
                                                    };
                                                },
                                                processResults: (data) => {
                                                    return {
                                                        results: data.results.map((item) => {
                                                            return { id: item.affidavit, text: item.text };
                                                        })
                                                    }
                                                }
                                            }
                                        }"
                                        @change="myChangeEvent($event)"
                                        @select="mySelectEvent($event)"
                                    />
                                </div>
                                <div class="col-4">
                                    <label for="common-remedies-ecoa-violations">Common Remedies ECOA Violations </label>
                                    <Select2
                                        v-model="selectedRemedyEcoaViolation"
                                        :settings="{
                                            multiple: true,
                                            ajax: {
                                                url: $router.resolve({
                                                    name: 'affidavitletter-categories',
                                                }).href,
                                                dataType: 'json',
                                                delay: 250,
                                                data: function (params) {
                                                    return {
                                                        search: params.term,
                                                        type: 'ecoa-violation'
                                                    };
                                                },
                                                processResults: (data) => {
                                                    return {
                                                        results: data.results.map((item) => {
                                                            return { id: item.affidavit, text: item.text };
                                                        })
                                                    }
                                                }
                                            }
                                        }"
                                        @change="myChangeEvent($event)"
                                        @select="mySelectEvent($event)"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <h4>APPEND CLIENT DOCUMENTS</h4>
                                    <div class="display-box mb-1">
                                        <div class="ml-2">
                                            <input
                                                class="custom-control-input"
                                                type="checkbox"
                                                name="append_affidavit"
                                                value="1"
                                                tabindex="4"
                                                v-model="checkbox"
                                                id="append_affidavit"

                                            />
                                            <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                ID Theft Affidavit
                                            </label>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <form >
                                <!-- <input type="hidden" name="_token" :value="csrf"> -->
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="creditorSelected.id" hidden>
                                <div class="col-md-12">
                                    <div id="editor">
                                        <editor
                                        id="affidavit_of_truth_letter"
                                        v-model="affidavit_of_truth_letter"
                                        :api-key="settingStore.tinymce.api_key"
                                        :init="settingStore.tinymce.configuration"
                                    />
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="button" name="editorType" value="1" @click.once="createLetter">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                        <button
                                            id="letter-rewrite"
                                            class="btn btn-outline-primary ml-1"
                                            @click="spin"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <b-popover
                                                target="letter-rewrite"
                                                placement="top"
                                                triggers="hover"
                                                :html="true"
                                            >
                                                <template #title>
                                                    {{ localizationStore.translate("chat.pricing.title") }}
                                                </template>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                            {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                        </p>
                                                        <p v-else>
                                                            {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#chat-modal"
                                            class="btn btn-outline-primary mx-1"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("chat.button.title") }}
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#top-up-modal"
                                            class="btn btn-outline-primary"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.purchase.button.text") }}
                                        </button>
                                    </div>
                                <div class="row">
                                    <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRefSingle' />
                                </div>
                            </div>
                            </form>

                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div style="page-break-after: always; padding: 15px 50px;">
                <div class="container">
                    <div class="row" style="">
                        <div class="col" style="display: inline-block; padding: 0px 50px;">
                            <p>
                                DATE: {{ userStore.user.tdate }}
                            </p>
                            <p>
                                {{ userInfo.firstname }} {{ userInfo.lastname }}
                                <br />
                                {{ userInfo.address }}
                                <br />
                                {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                            </p>
                        </div>
                        <div class="col" style="display: inline-block; padding: 0px 200px;">
                            <p>}
                                <br />}
                                <br />}
                                <br />
                            </p>
                        </div>
                        <div class="col" style="display: inline-block">
                            <p>
                                {{ creditorSelected.creditor_name }}
                                <br />
                                {{ creditorSelected.address_line }}
                                <br />
                                {{ creditorSelected.city }}, {{ creditorSelected.state }} {{ creditorSelected.zipcode }}
                            </p>
                        </div>
                    </div>
                    <hr />
                    <h2 style="text-align: center;">
                        <strong>AFFIDAVIT NOTICE</strong>
                    </h2>
                    <br />
                    <p>
                        <strong> ATTN:</strong>
                        {INSERT CFO/CEO | RISK MANAGEMENT}
                    </p>
                </div>
                <p class="letter-content">
                    I, agent for principal {{ userInfo.firstname }} {{ userInfo.lastname }} and affiant, I am a federally protected consumer, holder in due course, attorney, for any and all derivatives thereof for the surname/given name and I have been appointed and accept being the executor both public and private for all matters proceeding, and I hereby claim that I will d/b/a {{ userInfo.firstname }} {{ userInfo.lastname }}, and autograph as the agent and administrator in fact.
                </p>
                <ul>
                    <li v-for="remedyTilaViolation in selectedRemedyTilaViolation">{{ remedyTilaViolation }}</li>
                </ul>
                <ul>
                    <li v-for="remedyFdcpaViolation in selectedRemedyFdcpaViolation">{{ remedyFdcpaViolation }}</li>
                </ul>
                <ul>
                    <li v-for="remedyFcraViolation in selectedRemedyFcraViolation">{{ remedyFcraViolation }}</li>
                </ul>
                <ul>
                    <li v-for="remedyGlbViolation in selectedRemedyGlbViolation">{{ remedyGlbViolation }}</li>
                </ul>
                <ul>
                    <li v-for="remedyEcoaViolation in selectedRemedyEcoaViolation">{{ remedyEcoaViolation }}</li>
                </ul>
                <div style="page-break-after: always; padding: 15px 50px;">
                    <h2 style="text-align: center;">
                        <strong>JURAT</strong>
                    </h2>
                    <p class="letter-content">
                        Whereas, I of age, of majority, give this herein notice to all, I make a solemn oath to the one and only most high of creation only, whoever that may be, and I depose the following facts, so be it, nunc pro tunc
                    </p>
                    <p class="letter-content">
                        I swear to all information provided herein, I do so under the penalty of perjury that the information I so affirm to be true, correct, accurate to the best of my ability and knowledge, so be it.
                    </p>
                    <p class="letter-content">
                        On the date of ____________ , _________, agent, {{ userInfo.firstname }} {{ userInfo.lastname }} came before me today present as a flesh and blood living being (Non entity/non debtor) under oath to the most high of creation only and provided the facts listed herein
                    </p>
                    <br />
                    <br />
                    <p class="letter-content"> CLIENT NAME _____________________________ </p>
                    <p class="letter-content"> Sworn to or Affirmed by and subscribed before me on the _____day of, ____ year 20___ </p>
                    <br />
                    <p class="letter-content"> __________________________ Notary Name </p>
                    <br />
                    <p class="letter-content"> __________________________ Notary Signature.</p>
                    <br />
                    <br />
                    <br />
                    <p> Signature </p>
                </div>
            </div>
            <p class="page_break"></p>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import LaravelVuePagination from 'laravel-vue-pagination';
  import Select2 from 'vue3-select2-component';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useLetterStore } from '../../stores/LetterStore.js'
  import { usePlanStore } from '../../stores/PlanStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import Editor from '@tinymce/tinymce-vue'
  import { BPopover } from 'bootstrap-vue-3'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        'pagination': LaravelVuePagination,
        Select2,
        Editor
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            editorRefSingle: ref(null),
            date: ref(null),
            isInputFormActive: ref(true),
            haveCreditors: ref(null),
            localizationStore: useLocalizationStore(),
            affidavit_of_truth_letter:ref(null),
            userStore: useUserStore(),
            letterStore: useLetterStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            userInfo:reactive({}),
            checkbox:ref(false),
        };
    },
    created() {
    },
    data() {
        const creditorSelected = reactive([]);
        return {
            // Our data object that holds the Laravel paginator data
            creditors: {},
            selectedRemedyTilaViolation: '',
            selectedRemedyFdcpaViolation: '',
            selectedRemedyFcraViolation: '',
            selectedRemedyGlbViolation: '',
            selectedRemedyEcoaViolation: '',
            creditorSelected,
        }
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                this.date = value.tdate
                this.userInfo = value
            }
        },
    },
    mounted() {
        let $this = this;
        if(!_.isEmpty($this.userStore.user)){
            $this.date = $this.userStore.tdate
            $this.userInfo = $this.userStore.user
        }else{
            $this.userStore.fetchUser();
        }
        this.getCreditors();
    },
    computed: {
    },
    methods: {
        getCreditors(page = 1) {
            let $this = this;
            let params = {
                type: 1,
                letter: $this.$route.params.letter
            };
            if ($this.$route.params.client) {
                params.client = $this.$route.params.client
            }
            if ($this.$route.params.team) {
                params.team = $this.$route.params.team
            }
            const listCreditBureau = $this.$router.resolve({
                name: 'disputes-creditBureau',
                params: params
            });
            axios.get(listCreditBureau.href + '?page=' + page)
                .then(response => {
                    this.creditors = response.data;
                    if (this.creditors.data.length > 0) {
                        this.haveCreditors = true;
                    }
                    else {
                        this.haveCreditors = false;
                    }
                });
        },
        createLetter(){
            let $this = this;
            let params = { letter: this.$route.params.letter };
            if (this.$route.params.client) {
                params.client = this.$route.params.client
            }
            if (this.$route.params.team) {
                params.team = this.$route.params.team
            }
            const createLetterRoute = this.$router.resolve({
                name: 'create-letter',
                params: params
            });
            let payload = {
                'letter_id' : this.letterStore.getId(this.$route.params.letter),
                'creditbureau' : this.creditorSelected.id,
                'editor' : this.affidavit_of_truth_letter,
                'editorType':1,
                'append_affidavit': $this.checkbox,
            }
            axios.post(createLetterRoute.href, payload)
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    if($this.userStore.user.isDIY){
                        $this.$router.push({ name: 'disputes-report' });
                        return;
                    }
                    window.location.href = response.data.data.url;
                }, 3000)
            })
            .catch(function (error) {
                console.log(error);
            });


        },
        selectedCreditor(creditor) {
            this.creditorSelected = creditor;
            setTimeout(() => {
                this.affidavit_of_truth_letter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
                this.isInputFormActive = !this.isInputFormActive;
            }, "100");
        },
        goBack: function () {
            this.isInputFormActive = !this.isInputFormActive;
        },
        myChangeEvent(val){
            setTimeout(() => {
                this.affidavit_of_truth_letter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            }, "100");
        },
        mySelectEvent({id, text}){
            setTimeout(() => {
                this.affidavit_of_truth_letter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            }, "100");
        },
        spin() {
            this.$refs.spinner.spin(tinymce.get('affidavit_of_truth_letter'))
        },
        changeCheckbox(){
            this.checkbox = !this.checkbox
        }
    }
  };
</script>
<style scoped>
.card-developer-meetup {
    background: #f3f2f7;
}
</style>
